module.exports = __webpack_public_path__ + "img/quickwit.835c1027.svg";